import type {
  DynamicBlock,
  QueryDynamicBlockByKeyArgs,
} from '@tribeplatform/gql-client/types'
import type { DynamicBlockFields } from '@tribeplatform/gql-client/types/generated'

import {
  useQuery,
  type UseQueryOptions,
} from '../../lib/react-query/useQuery.js'
import { useTribeClient } from '../../useTribeClient.js'
import { getDynamicBlockByKeyKey } from '../../utils/keys/app.key.js'

export const useDynamicBlockByKey = (options: {
  variables: QueryDynamicBlockByKeyArgs
  fields?: DynamicBlockFields
  useQueryOptions?: UseQueryOptions<DynamicBlock>
}) => {
  const { variables, fields = 'basic', useQueryOptions } = options
  const { client } = useTribeClient()
  const dynamicBlockKey = getDynamicBlockByKeyKey({ variables, fields })

  return useQuery<DynamicBlock>(
    dynamicBlockKey,
    () =>
      client.query({ name: 'dynamicBlockByKey', args: { variables, fields } }),
    useQueryOptions,
  )
}
